// src/utils/related-products.js
var RelatedProducts = class extends HTMLElement {
  constructor() {
    super();
    const loadProductRecommendationsIntoSection = async () => {
      const relatedProductsElement = this;
      if (relatedProductsElement === null) {
        return;
      }
      relatedProductsElement.setAttribute("aria-busy", "true");
      const productId = relatedProductsElement.dataset.productId;
      const sectionId = relatedProductsElement.dataset.sectionId;
      const baseUrl = relatedProductsElement.getAttribute("data-base-url");
      const limit = relatedProductsElement.dataset.limit;
      const intent = relatedProductsElement.dataset.intentType;
      const url = new URL(`${window.location.origin}${baseUrl}`);
      url.searchParams.append("section_id", sectionId);
      url.searchParams.append("limit", limit);
      url.searchParams.append("product_id", productId);
      url.searchParams.append("intent", intent);
      try {
        const responseData = await fetch(url.toString(), {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            "X-Requested-With": "xmlhttprequest"
          }
        }).then((r) => r.text());
        let newRecommendedProductsElement = new DOMParser().parseFromString(responseData, "text/html").querySelector("related-products");
        relatedProductsElement.innerHTML = newRecommendedProductsElement.innerHTML;
      } catch (error) {
        console.log(error);
      } finally {
        relatedProductsElement.setAttribute("aria-busy", "false");
      }
    };
    loadProductRecommendationsIntoSection();
  }
};
customElements.define("related-products", RelatedProducts);
